import { Reducer } from "redux";
import { dataTranscriberOptionId } from "../../../shared/optionIds";
import { IDataTranscribeQueueState, DataTranscribeQueueActionTypes } from "../types";

// Type-safe initialState!
const initialState: IDataTranscribeQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  loadingWorkflowSteps: false,
  totalWorkflowItemSteps: 0,
};

const reducer: Reducer<IDataTranscribeQueueState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case DataTranscribeQueueActionTypes.LOADING_WORKFLOW_STEPS: {
      return { ...state, loadingWorkflowSteps: action.value };
    }
    case DataTranscribeQueueActionTypes.TOTAL_WORKFLOW_STEPS: {
      return { ...state, totalWorkflowItemSteps: action.value };
    }
    case DataTranscribeQueueActionTypes.SEARCH_REPORTS: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DataTranscribeQueueActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataTranscribeQueueActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataTranscribeQueueActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      return _state;
    }
    case DataTranscribeQueueActionTypes.COMPLETE_DATA_ENTRY: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
